module.exports = __webpack_public_path__ + "img/personal-faq.a07891b3.svg";